<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in"></notifications>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <v-dialog/>
<!-- 
    <modal
      name="mainInfoModal"
      :draggable="true"
      height="300"
      footerClasses="justify-content-center"
      type="notice">
      <card>
        <span v-html="mainInfo.infoHtml"></span>
      </card>
    </modal> -->

    <vue-simple-spinner size="huge" :class="{'show':$store.state.common.spinnerVisible}"></vue-simple-spinner>
  </div>
</template>

<script>
    import Vue from 'vue'
    import { Dialog } from '@/components/UIComponents/VModal'
    import { Card } from 'src/components/UIComponents';
    import { mapState } from 'vuex';
    import MainInfoProxy from "./proxies/MainInfoProxy";
    import vueSimpleSpinner from 'vue-simple-spinner'
    
    // Vue.use(Vmodal, {dialog:true})
    export default {
        components: {
            Card,
            vueSimpleSpinner,
            'v-dialog' : Dialog
        },
        watch: {
            // 클래스 바인딩 확인용
            mainInfoAlias(newValue, oldValue) {
                if(newValue) {
                    this.showModal( newValue.roleCode );
                }
            },
        },
        computed: {
            ...mapState({
                mainInfoAlias: state => state.common.mainInfo,
            }),
        },
        data() {
            return {
                mainInfo: {}
            }
        },
        mounted() {
            //this.showModal( 'ADMIN' );
        },
        methods: {
            showModal( roleCode ) {
                
                new MainInfoProxy()
                        .find(roleCode)
                        .then((response) => {
                            if(response.mainInfo !== undefined) {
                                if(response.mainInfo.show) {
                                    this.mainInfo = response.mainInfo;

                                    this.$modal.show(
                                        () => import('@/components/Pages/Views/Common/Welcome.vue'),
                                        { text: this.mainInfo.infoHtml, fileName:  response.mainInfo.fileName, roleCode: roleCode },
                                        { draggable: false, width:'800px', height: 'auto' },
                                        { }                                        
                                    )

                                    /*
                                    this.$modal.show('dialog', {
                                        dialog: true,
                                        text: this.mainInfo.infoHtml,
                                        buttons: response.mainInfo.fileName === undefined ? [{title: '닫기'}] :
                                          [
                                            {
                                                title: '닫기'
                                            },
                                            {
                                              title: '첨부파일 다운로드',
                                              handler: () => { location.href = "/api/settings/info/" + roleCode + "/download?authorization=" + $cookies.get('id_token'); }
                                            }
                                          ]
                                    });
                                    */
                                }
                            }
                        });                
            }
        }
    }
</script>
<style lang="css">
.vue-simple-spinner {
    position: absolute;
    transform: translate(-50%,-50%);
    left: 50%;
    top: 50%;
    display: none;
}
.show .vue-simple-spinner {
    display:block;
    z-index: 2147483647
}
</style>
